import { FormikHelpers } from "formik";
import BillingUploadForm from "./BillingUploadForm";
import { fileUploadInitialFormData } from "./data/fileUploadData";
import { useCheckFileImport } from "./api/checkFileImport";
import { useContext } from "react";
import { BillingUploadContext } from "./BillingUploadContext";

const FormSection = () => {
  const checkFileImportMutation = useCheckFileImport({data: fileUploadInitialFormData});
  const billingUploadCtx = useContext(BillingUploadContext);

  const handleFormSubmit = async (values: IBillingUploadForm, { setSubmitting }: FormikHelpers<IBillingUploadForm>): Promise<void> => {
    try {
      await checkFileImportMutation.mutateAsync({
        data: values,
      }).then(response => {
        billingUploadCtx.saveUserFormData(values)
        billingUploadCtx.handleChangeStatus(response.hasBilling ? "pending" : "approved");
      }).catch((error) => {
        console.log(error)
        billingUploadCtx.handleChangeStatus("blocked");
      });
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }
  
  return (
    <div className="bg-light p-3 mb-3 border border-2 rounded">
      <BillingUploadForm initialValues={fileUploadInitialFormData} onSubmit={handleFormSubmit} />
    </div>
  )
}

export default FormSection;